'use client';

import React, { useCallback, useState } from 'react';
import Button from 'components/commercetools-ui/atoms/button';
import { IoChatbubbleEllipsesOutline } from 'react-icons/io5';
import { FEEDBACK_URL } from 'helpers/constants/envVariables';
import Modal from 'components/commercetools-ui/atoms/modal';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop } from 'helpers/utils/screensizes';

interface FeedbackProps {
  locale: string;
}
const FeedbackButton: React.FC<FeedbackProps> = ({ locale }) => {
  const [isOpen, setIsOpen] = useState(false);
  const closeModal = useCallback(() => setIsOpen(false), []);
  const [isDesktopSize] = useMediaQuery(desktop);
  return (
    <div className="fixed bottom-1/2 right-12 z-50 translate-x-1/2 -rotate-90 transform md:bottom-0 md:right-20 md:translate-x-0 md:rotate-0">
      <Button
        className="gap-6 border border-black !bg-[#e5e9eb] px-8 py-4 !text-10 !text-black hover:bg-gray-200 md:py-6 md:!text-12"
        icon={<IoChatbubbleEllipsesOutline />}
        iconPosition="left"
        onClick={() => {
          setIsOpen(true);
        }}
      >
        Share Feedback
      </Button>

      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        style={{
          content: { backgroundColor: 'white', padding: '5px', height: isDesktopSize?'77.5vh':'65vh',maxWidth:isDesktopSize?'65vh':'85%' },
          overlay: { backgroundColor: 'rgba(0, 0, 0, 0.65)' },
        }}
        closeButton
        className="border-transparent focus:border-transparent focus:outline-none focus:ring-0"
      >
      {typeof window !== "undefined" && (
         <embed
          className="h-full w-full"
          src={encodeURI(`${FEEDBACK_URL},"Source":"${encodeURIComponent(`${window.location.origin}/${locale}`)}"}`)}
        ></embed> 
      )}
      </Modal>
    </div>
  );
};
export default FeedbackButton;
